<script>
  import SinInformacion from "../Sin_informacion.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import { get } from "svelte/store"

  let session_key = $user.session_key

  let producto = {
    nombre: "",
    id_segmento: "0",
  }
  export let segmentos = []
  let productos = []
  let isAdding = false

  const addProducto = async () => {
    if (producto.nombre.trim() === "" || producto.id_segmento === "0") {
      alert("Por favor, complete todos los campos.")
      return
    }

    isAdding = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "addProducto",
        nombre: producto.nombre,
        id_segmento: producto.id_segmento,
        session_key: session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      producto = {
        nombre: "",
        id_segmento: "0",
      }
      getProductos()
    } else {
      alert(data.message || "Error al agregar el producto.")
    }
    isAdding = false
  }

  const deleteProducto = async (id, nombre) => {
    if (
      !confirm(`¿Está seguro de que desea eliminar el producto: ${nombre}?`)
    ) {
      return
    }

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "deleteProducto",
        id,
        session_key: get(user).session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      getProductos()
    } else {
      alert(data.message || "Error al eliminar el producto.")
    }
  }

  const getProductos = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=getProductos&session_key=${session_key}`,
    )
    const data = await response.json()
    if (data.status === "ok") {
      productos = data.data
    } else {
      productos = []
    }
  }

  getProductos()
</script>

<div>
  <div class="row g-3">
    <div class="col-12 lg:col-6">
      <label for="producto_segmento" class="form-label small fg-secondary"
        >Segmento</label
      >
      <select
        id="producto_segmento"
        class="form-control form-control-sm"
        bind:value={producto.id_segmento}
      >
        <option value="0">Seleccionar segmento</option>
        {#each segmentos as segmento}
          <option value={segmento.id}>{segmento.nombre}</option>
        {/each}
      </select>
    </div>

    <div class="col-12 lg:col-6">
      <label for="producto_nombre" class="form-label small fg-secondary"
        >Producto</label
      >
      <input
        type="text"
        id="producto_nombre"
        class="form-control form-control-sm"
        placeholder="Ingrese el nombre del producto"
        bind:value={producto.nombre}
      />
    </div>

    <div class="col-12 text-end">
      {#if isAdding}
        <button class="btn btn-solid theme-primary btn-sm disabled" disabled
          ><i class="bi bi-plus"></i>Agregando...</button
        >
      {:else}
        <button
          class="btn btn-solid theme-primary btn-sm"
          on:click={addProducto}><i class="bi bi-plus"></i>Agregar</button
        >
      {/if}
    </div>
  </div>

  <div class="table-responsive mb-3">
    <table class="table table-striped table-sm small">
      <thead>
        <tr>
          <th class="fg-secondary fw-normal">Segmento</th>
          <th class="fg-secondary fw-normal">Producto</th>
          <th class="fg-secondary fw-normal"></th>
        </tr>
      </thead>
      <tbody>
        {#each productos as producto}
          <tr>
            <td>{producto.segmento}</td>
            <td>{producto.nombre}</td>
            <td class="text-end">
              {#if producto.cantidad_clientes == 0}
                <button
                  class="btn btn-solid btn-xs theme-danger py-0 px-1"
                  on:click={() => deleteProducto(producto.id, producto.nombre)}
                >
                  <i class="bi bi-trash"></i>
                </button>
              {:else}
                <span class="badge badge-subtle theme-secondary">Inactivo</span>
              {/if}
            </td>
          </tr>
        {:else}
          <tr>
            <td colspan="3" class="text-center">
              <SinInformacion message="No hay productos para mostrar" />
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>
